// Thrown instead of silently returning a $0 price when an item has no resolvable price row
// (e.g. a stale cart item left over from a different store) -- ADO Bug 86902.
export class ItemPricingUnavailableError extends Error {
    public readonly itemId: number;
    public readonly sizeId: number;

    constructor(itemId: number, sizeId: number) {
        super(`No price available for ItemId ${itemId} at SizeId ${sizeId}`);
        this.name = "ItemPricingUnavailableError";
        this.itemId = itemId;
        this.sizeId = sizeId;
    }
}
